module.exports = __webpack_public_path__ + "src/assets/ro.c0876dd6.png";